import { render, staticRenderFns } from "./BatchInfoCard.vue?vue&type=template&id=f1d1c826&scoped=true&"
import script from "./BatchInfoCard.vue?vue&type=script&lang=js&"
export * from "./BatchInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BatchInfoCard.vue?vue&type=style&index=0&id=f1d1c826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d1c826",
  null
  
)

export default component.exports